export default __webpack_public_path__ + "static/media/WpdLogoWithText.1bfc7960.svg";